import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
import { getAnchorElementFromEvent } from '@noths/polaris-client-utils';

import { PlacementContext } from 'src/types/PlacementContext';

export const trackImpression = ({ trackingPosition, trackingTitle }: PlacementContext) => {
  sendGAEvent({
    event: 'custom_event',
    event_action: 'Impression',
    event_category: `${trackingPosition} | CTA button`,
    event_label: `${trackingPosition} | ${trackingTitle}`.toLowerCase(),
    event_name: 'view_content',
    content_position: `${trackingPosition}`,
    content_type: `cta button|${trackingTitle}`.toLowerCase(),
  });
};

export const trackLinkClick = (
  e: React.MouseEvent<HTMLAnchorElement>,
  { trackingPosition, trackingTitle }: PlacementContext,
) => {
  const element = getAnchorElementFromEvent(e);

  if (element) {
    const { text, href } = element;
    sendGALinkClickEvent(e, {
      event: 'custom_event',
      event_action: 'CTA click',
      event_category: `${trackingPosition} | CTA button`,
      event_label: `${trackingPosition} | ${trackingTitle} | cta`.toLowerCase(),
      event_name: 'select_content',
      event_details: 'cta click',
      content_position: `${trackingPosition}`,
      content_type: `cta button|${trackingTitle}`.toLowerCase(),
      destination_URL: href,
      item_id: text.toLowerCase(),
    });
  }
};
